import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colorPalette } from '@qualifio/ui-commons';
import { useTranslation } from 'react-i18next';
import { MarkerProps } from './types';
import { blockedMemberIcon } from '../icons';

export const blockedMemberColor = colorPalette.red.main;

export function BlockedMemberMarker({
  size = 'sm',
  sx,
  tooltipProps,
  ...props
}: MarkerProps): React.ReactElement {
  const { t } = useTranslation();

  return (
    <Tooltip title={t('markers.blocked-member')} placement="top" mode="title" {...tooltipProps}>
      <Box
        component={FontAwesomeIcon}
        icon={blockedMemberIcon}
        color={blockedMemberColor}
        size={size}
        sx={sx}
        {...(props as any)}
      />
    </Tooltip>
  );
}
